import { AppLogoImage } from 'components/icons';

export default function AppSplash() {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <AppLogoImage />
    </div>
  );
}
